import { APPID, APPVERSION } from "../common/globals";
import { BASE_AXIOS } from "../config";

export const apiGetQuestion = async (request, type) => {
    let form = new FormData();
    
    form.append("mcid", request.mcid);
    form.append("gameMode", request.gamemode);
    form.append("key", request.key);

    if (typeof request.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", request.tracking.pathname);
        form.append("pagevia", request.tracking.pagevia);
        form.append("action", 'get questions');
        form.append("os", request.tracking.os);
        form.append("ua", request.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    if(typeof request.deckID !== 'undefined' && (request.gamemode > 2)) {
        form.append("deckID", request.deckID);
        form.append('detail', request.deckID);
        form.append('detailvar', 'deckID');
    } 
    
    if (typeof request.yearvar !== 'undefined' && request.yearvar) {
        form.append("yearvar", request.yearvar);
        form.append('detail', request.yearvar);
        form.append('detailvar', 'yearvar');
    }
    
    if (typeof request.areavar !== 'undefined' && request.areavar) {
        form.append("areavar", request.areavar);
    }
    
    if (typeof request.questionID !== 'undefined') { 
        form.append('questionID', request.questionID);
        form.append('detailvar2', request.questionID);
    }

    if (typeof request.previousQuestionID !== 'undefined') { 
        form.append('previousQuestionID', request.previousQuestionID);
    }

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getQuestion"
            },
            data: form
        });

        let temp = response.data;

        if (Array.isArray(temp)) {
            temp = temp[0];
        } else if (typeof temp.explanation !== 'undefined' && temp.explanation !== '') {
            temp = temp;
        } else if (!Array.isArray(temp)) {
            temp = [];
        }

        return temp;

    } catch(error) {
        throw error;
    }
}

export const apiRemoveQuestion = async (request) => {
    let form = new FormData();
    form.append("mcid", request.mcid);
    form.append("key", request.key);
    form.append("deckID", request.deckID);
    form.append('questionID', request.questionid);

    if (typeof request.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", request.tracking.pathname);
        form.append("pagevia", request.tracking.pagevia);
        form.append("action", 'get questions');
        form.append("os", request.tracking.os);
        form.append("ua", request.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    }

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "removeQuestion"
            },
            data: form
        });

        let temp = response.data;

        return temp;

    } catch(error) {
        throw error;
    }
}

export const apiGetSingleQuestion = async (request, type) => {
    let form = new FormData();
    let obj = {
        mcid: request.mcid,
        questionid: request.questionid,
        key: request.key,
    };
    form.append("mcid", request.mcid);
    form.append("gameMode", request.gamemode);
    form.append("questionid", request.questionid);
    form.append("key", request.key);

    if (typeof request.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", request.tracking.pathname);
        form.append("pagevia", request.tracking.pagevia);
        form.append("action", 'get questions');
        form.append("os", request.tracking.os);
        form.append("ua", request.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
        form.append('detail', request.questionid);
        form.append('detailvar', 'questionID');
    } 

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getSingleQuestion"
            },
            data: form
        });

        let temp = response.data;

        if (Array.isArray(temp)) {
            temp = temp[0];
        } else if (!Array.isArray(temp)) {
            temp = [];
        }

        return temp;

    } catch(error) {
        throw error;
    }
}